import store from './store';

export const getIsLoading = store.get('isLoading');
